import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'models/store';
import { ReservedCapacityGuardingActionStatusEnum } from '../dispatcherReservedCapacityGuardingTypes';

// ==============================|| DISPATCHER SELECTORS ||============================== //

export const selectDispatcherCodebooks = (state: RootState) =>
  state.dispatcher.codebooks;

export const selectDispatcherContextActions = (state: RootState) =>
  state.dispatcher.contextActions;

export const selectSseToken = (state: RootState) => state.dispatcher.sseToken;

export const selectDispatcherCodeBooks = (state: RootState) =>
  state.dispatcher.codebooks;

export const selectOperationEvents = (state: RootState) =>
  state.dispatcher.operationCalendar.events;

export const selectOperationCalendars = (state: RootState) =>
  state.dispatcher.operationCalendar.calendarList;

export const selectOperationEventDetail = (state: RootState) =>
  state.dispatcher.operationCalendar.eventDetail;

export const selectActivityEvents = (state: RootState) =>
  state.dispatcher.operationCalendar.activityEvents;

export const selectDispatcherEtagList = (state: RootState) =>
  state.dispatcher.etag;

export const selectTimeSeriesListForOnlineDispatching = (state: RootState) =>
  state.dispatcher.timeSeriesListForOnlineDispatching;

export const selectTimeSeriesListForPlanning = createSelector(
  (state: RootState) => state.dispatcher.timeSeriesListForPlanning,
  (timeSeriesListForPlanning) => [
    ...timeSeriesListForPlanning.SYSTEM,
    ...timeSeriesListForPlanning.BALANCING_GROUP,
    ...timeSeriesListForPlanning.DELIVERY_POINT,
    ...timeSeriesListForPlanning.DEVICE
  ]
);

export const selectTimeSeriesListForPlanningSystem = (state: RootState) =>
  state.dispatcher.timeSeriesListForPlanning.SYSTEM;

export const selectTimeSeriesListForPlanningBalancingGroup = (
  state: RootState
) => state.dispatcher.timeSeriesListForPlanning.BALANCING_GROUP;

export const selectTimeSeriesListForPlanningDeliveryPoint = (
  state: RootState
) => state.dispatcher.timeSeriesListForPlanning.DELIVERY_POINT;

export const selectTimeSeriesListForPlanningDevice = (state: RootState) =>
  state.dispatcher.timeSeriesListForPlanning.DEVICE;

export const selectTimeSeriesListForHxBalancingGroup = (state: RootState) =>
  state.dispatcher.timeSeriesListForHx.BALANCING_GROUP;

export const selectTimeSeriesListForHxSystem = (state: RootState) =>
  state.dispatcher.timeSeriesListForHx.SYSTEM;

export const selectTimeSeriesListForHxDevice = (state: RootState) =>
  state.dispatcher.timeSeriesListForHx.DEVICE;

export const selectTimeSeriesListForReservedCapacityGuardingDeliveryPoint = (
  state: RootState
) => state.dispatcher.timeSeriesListForReservedCapacityGuarding.DELIVERY_POINT;

export const selectTimeSeriesListForReservedCapacityGuardingDevice = (
  state: RootState
) => state.dispatcher.timeSeriesListForReservedCapacityGuarding.DEVICE;

export const selectMetricSpecs = (state: RootState) =>
  state.dispatcher.metricSpecs;

export const selectDeliveryPointListWithoutPaging = (state: RootState) =>
  state.dispatcher.balancingGroup.deliveryPointList;

export const selectCalendarActivityLog = (state: RootState) =>
  state.dispatcher.calendarActivityLog;

export const selectActivityLogs = (state: RootState) =>
  state.dispatcher.activityLogs;

export const selectReservedCapacityGuardingActions = (state: RootState) =>
  state.dispatcher.reservedCapacityGuardingActions;

export const selectAcceptedReservedCapacityGuardingActions = createSelector(
  selectReservedCapacityGuardingActions,
  (items) =>
    items.filter(
      (item) =>
        item.status === ReservedCapacityGuardingActionStatusEnum.Accepted
    )
);

export const selectIsReservedCapacityGuardingActionsReady = (
  state: RootState
) => state.dispatcher.isReservedCapacityGuardingActionsReady;

export const selectAlarms = (state: RootState) => state.dispatcher.alarms;
